export const CreditCardFormProgressTexts = {
  Title: 'Точность расчета',
};
